import { useMutation } from '@tanstack/react-query'
import { publicApi } from '@/lib/api'

export function useCheckPublicWitness() {
  return useMutation({
    mutationFn: async (cpf: string) => {
      const response = await publicApi.get(`/signatures/public/witness/${cpf}`)
      if (!response.data?.data) {
        throw new Error('Erro ao verificar testemunha')
      }

      return response.data.data as {
        exists: boolean
        witness: {
          id?: number
          nome?: string
          cpf?: string
        } | null
      }
    }
  })
}
